import React from 'react';
import './HomePage.css'

const HomePage = () => {
    return (
        <div className='home-page'>
            <h1>Welcome To The Quizzify!!!</h1>  
        </div>
    );
};

export default HomePage;